import React from 'react';
import { createRoot } from 'react-dom/client';
// The brand, from the one file the app, the TV and cjas.no also use.
import '../../../prototype/assets/tokens.css';
import './styles/panel.css';
import favicon from '../../../brand/icon-favicon.svg';
import { App } from './App';
import { Toaster } from './components/Toaster';
import { installReporting } from './lib/report';

installReporting();
/*
 * Light or dark (Masjid UX redesign, 2026-10-23): the panel follows the computer's setting, using the dark values
 * tokens.css already has under [data-theme="dark"]. `?theme=light|dark` pins it (for screenshots and for a shared
 * office computer set to dark that someone finds hard to read).
 */
const pinned = new URLSearchParams(location.search).get('theme');
const darkQuery = window.matchMedia ? window.matchMedia('(prefers-color-scheme: dark)') : null;
const applyTheme = () => {
  const dark = pinned === 'dark' || (pinned !== 'light' && Boolean(darkQuery && darkQuery.matches));
  document.documentElement.dataset.theme = dark ? 'dark' : 'light';
  document.documentElement.style.colorScheme = dark ? 'dark' : 'light';
};
applyTheme();
darkQuery?.addEventListener?.('change', applyTheme);
const link = document.getElementById('favicon') as HTMLLinkElement | null;
if (link) link.href = favicon;
createRoot(document.getElementById('root')!).render(<React.StrictMode><App /><Toaster /></React.StrictMode>);
